// supabase/functions/sms-deposit/matcher.ts 의 normalizeName 과 byte-동일 미러.
// NFC → trim → 내부 공백 전부 제거(한글 이름 띄어쓰기 흡수). 변경 시 양쪽 동기화 —
// amber 분류(프론트)가 자동매칭(엣지)과 어긋나면 안 된다. shippingAmounts.ts 미러 규율과 동일.
export function normalizeName(s: string): string {
  return (s ?? '').normalize('NFC').trim().replace(/\s+/g, '');
}
